var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['image-with-transforms-container', _vm.blockWidthClass]},[_c('div',{staticClass:"position-anchor"},[_c('div',{ref:"containerRef",staticClass:"image-container"},[_c('div',{ref:"insideRef",staticClass:"image-inside"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }